import React from 'react';

import renderNumbers from '../../elements/lotteries/Numbers';

import Card from 'crm/elements/common/Card';
import Row, { TableDetailsBody } from 'crm/elements/common/TableDetailsRow';
import { formatDateStringWithTimezone as formatDateStringWithTz } from 'utils/formatters';

function DrawDetails({ draw }) {
    return (
        <Card title="Draw details">
            <TableDetailsBody>
                <Row label="Draw number">{draw.draw_no}</Row>
                <Row label="Date">{formatDateStringWithTz(draw.date)}</Row>
                <Row label="Exact start">{formatDateStringWithTz(draw.exact_start)}</Row>
                <Row label="Exact end">{formatDateStringWithTz(draw.exact_end)}</Row>
                <Row label="Jackpot">{draw.jackpot_formatted}</Row>
                <Row label="Draw numbers">{renderNumbers(draw.numbers, draw.lottery_id, draw.type)}</Row>
                <Row label="Total prize">{draw.prize_total_formatted}</Row>
                <Row label="Tickets">{draw.tickets_count}</Row>
                <Row label="Lines">{draw.lines_count}</Row>
                <Row label="Won lines">{draw.lines_won_count}</Row>
            </TableDetailsBody>
        </Card>
    );
}

export default DrawDetails;
